import { Breadcrumbs, Button, Divider, Grid, IconButton, Link, useMediaQuery } from '@mui/material'
import React, { useEffect } from 'react'
import { Outlet, useNavigate, useSearchParams } from 'react-router-dom'
import GlobalPageHeaderText from '../../utility/globalPageHeaderText'
import globalStyles from '../../../assets/styles/global.module.scss'
import styles from '../../../assets/styles/componentStyles/chatbotStyles/integrations.module.scss'
import AddIcon from '@mui/icons-material/Add'
import createPersonaIcon from "../../../assets/createPersona.png";
import templateStyles from '../../../assets/styles/componentStyles/template.module.scss'
import IconsColor from '../../utility/iconsColor'
import { IntegrationContext, IntegrationContextPayload } from '../../../context/integrationContext'
import { metaIntegrationFaceBookDataNew, metaIntegrationWhatsAppDataNew, metIntegrationInstagramDataNew } from '../../../models/axiosModel'
import { GenericDataContext, GenericDataContextPayload } from '../../../context/genericDataContext'
import { accountSetupBreadcrumb, channelsBreadcrumb, homeBreadcrumb } from '../../../utils/breadcrumb'

const FacebookIntegration = () => {
    const navigate = useNavigate();
    const { integrationListNewStructure } = React.useContext(IntegrationContext) as IntegrationContextPayload;
    const { breadcrumbs, setBreadCrumbs } = React.useContext(GenericDataContext) as GenericDataContextPayload;
    const [searchParams, setSearchParams] = useSearchParams()
    let id = searchParams.get('id')
    const smallScreen = useMediaQuery<boolean>('(max-width : 600px) and (min-width : 0px)')
    let pathname = window.location.pathname.toLowerCase();

    const getPageName = () => {
        let pageName = "Facebook";
        if (integrationListNewStructure) {
            const obj = integrationListNewStructure?.find((list: metaIntegrationWhatsAppDataNew | metaIntegrationFaceBookDataNew | metIntegrationInstagramDataNew) => list.integrated_channel_id == searchParams.get('id'));
            if (obj) {
                if ("page_name" in obj) {
                    pageName = obj.page_name;
                }
            }
        }
        return pageName;
    } 

    useEffect(() => {
        if(id){
            const updatedBreadcrumbs = [
                homeBreadcrumb, 
                {...channelsBreadcrumb}, 
                {name: getPageName(), path: `/channels/viewintegration/facebook?id=${id}`, isActive: false, isSamePageRedirecting: pathname === "/channels/viewintegration/facebook"}, 
                {...accountSetupBreadcrumb, isActive: true}
            ];
            setBreadCrumbs(updatedBreadcrumbs);
        }else{
            setBreadCrumbs([homeBreadcrumb, {...channelsBreadcrumb} , {...accountSetupBreadcrumb, isActive: true}]);
        }
    }, [id, integrationListNewStructure]);

    return (
        <>{pathname !== '/channels/viewintegration/facebook/templateinfo' &&
            <Grid item xl={12} lg={12} md={12} sm={12} xs={12} className={`${globalStyles.fullwidth} ${styles.templateWrapper}`}>
                <Grid container sx={{ padding: { xs: "15px 20px 0px 20px", lg: "25px 25px 0px 27px" } }}>
                    <Grid item xs={12}>
                        <Grid container className={globalStyles.createChatbotContainer}>
                            <Grid item xl={6} lg={5} md={9} sm={9} xs={9} sx={{ marginBottom: { xs: "0px", lg: "10px" } }}>
                                <GlobalPageHeaderText
                                    mainHeadText={
                                        pathname === '/channels/viewintegration/facebook/templatemessages' && id ? "Template Messages" :
                                            pathname === '/channels/viewintegration/facebook/templateinfo' && id ? "Template Info" :
                                                pathname === '/channels/viewintegration/facebook/pages' && id ? "Pages" :
                                                    // id ? "WhatsApp Integration" : "New Integration"}
                                                    id ? "Account Setup" : "New Channel"}
                                    flagMainTextOnly
                                />
                            </Grid>
                            {pathname === '/channels/viewintegration/facebook/templatemessages' &&
                                <Grid item xl={6} lg={7} md={2.5} sm={2.5} xs={2.5} paddingRight={{ xs: "5px", lg: "0px" }}>
                                    <Grid container className={`${globalStyles.globalHeadMainItemRightContainer}`} justifyContent={{ lg: "end", xs: "end" }}>
                                        <Grid item xl={4} lg={5} md={4.5} sm={2.5} xs={2.5} className={`${globalStyles.globalHeadRightSubItem}`}>
                                            <Grid container className={globalStyles.createChatbotContainer}>
                                                <Grid item className={`${globalStyles.globalNewAddBtnItem} ${templateStyles.addChatbotBtn}`}>
                                                    <Button
                                                        variant='outlined'
                                                        size='large'
                                                        fullWidth
                                                        startIcon={<IconsColor iconName="plus" fillColor="#fff" width="15px" height="15px" />}
                                                        className={globalStyles.addDocumentBtn}
                                                        onClick={() => navigate(`/channels/viewintegration/facebook/templateinfo?id=${id}`)}
                                                    >
                                                        Create Template
                                                    </Button>
                                                </Grid>
                                                <Grid item>
                                                    <IconButton
                                                        className={`${globalStyles.cmpGlobalMobileAddIcon} ${templateStyles.addChatbotIcon}`}
                                                        onClick={() => navigate(`/channels/viewintegration/facebook/templatemessages?id=${id}`)}
                                                        style={{ zIndex: "1" }}
                                                    >
                                                        <AddIcon style={{ height: "28px", width: 'auto' }} />
                                                    </IconButton>
                                                </Grid>
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                </Grid>
                            }
                            {!smallScreen && <Divider className={`${globalStyles.fullwidth} ${globalStyles.dividerStyles}`} />}
                            <Outlet />
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>
        }
            {pathname === '/channels/viewintegration/facebook/templateinfo' && <Outlet />}
        </>
    )
}

export default FacebookIntegration
